/* eslint-disable max-lines */
import imageAccuro from '@/assets/image/integrations/accuro.svg';
import imageAthena from '@/assets/image/integrations/athena.svg';
import imageBP from '@/assets/image/integrations/best-practice.svg';
import imageCliniko from '@/assets/image/integrations/cliniko.svg';
import imageEclinicalWorks from '@/assets/image/integrations/eclinicalworks.svg';
import imageEpic from '@/assets/image/integrations/epic.svg';
import ImageHealthdirect from '@/assets/image/integrations/healthdirect.svg';
import imageMagentus from '@/assets/image/integrations/magentus.svg';
import imageMindbody from '@/assets/image/integrations/mindbody.svg';
import imageNookal from '@/assets/image/integrations/nookal.svg';
import imageVeradigm from '@/assets/image/integrations/veradigm.svg';
import { EHRProvider } from '@heidi/schema/ml-scribe';

// Partial: the EHRProvider enum lists every backend-known EMR, far more than
// the subset with Heidi icon/name metadata. Consumers guard on presence.
export const integrationMapping: Partial<
  Record<EHRProvider, { icon: string; name: string; ehrLaunch?: boolean }>
> = {
  [EHRProvider.Elixir]: {
    icon: '',
    name: 'Elixir',
  },
  [EHRProvider.Cliniko]: {
    icon: imageCliniko,
    name: 'Cliniko',
  },
  [EHRProvider.Best_Practice]: {
    icon: imageBP,
    name: 'BP',
  },
  [EHRProvider.MediRecords]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Medical_Director]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Zedmed]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Genie]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Genie_Web]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Pracsoft]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Medtech]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Clinic_to_Cloud]: {
    icon: '',
    name: '',
  },
  [EHRProvider.MedicalMinded]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Epic_Systems]: {
    icon: imageEpic,
    name: 'Epic',
    ehrLaunch: true,
  },
  [EHRProvider.Cerner]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Cerner_EHR_Launch]: {
    icon: '',
    name: '',
    ehrLaunch: true,
  },
  [EHRProvider.Cerbo]: {
    icon: '',
    name: '',
  },
  [EHRProvider.athenahealth]: {
    icon: imageAthena,
    name: 'Athena',
  },
  [EHRProvider.eClinicalWorks]: {
    icon: imageEclinicalWorks,
    name: 'eClinicalWorks',
  },
  [EHRProvider.Allscripts]: {
    icon: '',
    name: '',
  },
  [EHRProvider.NextGen_Healthcare]: {
    icon: '',
    name: '',
  },
  [EHRProvider.DrChrono]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Greenway_Health]: {
    icon: '',
    name: '',
  },
  [EHRProvider.CureMD]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Kareo]: {
    icon: '',
    name: '',
  },
  [EHRProvider.AdvancedMD]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Practice_Fusion]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Aprima]: {
    icon: '',
    name: '',
  },
  [EHRProvider.AmazingCharts]: {
    icon: '',
    name: '',
  },
  [EHRProvider.ChartLogic]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Modernizing_Medicine]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Compulink]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Nextech]: {
    icon: '',
    name: '',
  },
  [EHRProvider.RevolutionEHR]: {
    icon: '',
    name: '',
  },
  [EHRProvider.CareCloud]: {
    icon: '',
    name: '',
  },
  [EHRProvider.EMIS]: {
    icon: '',
    name: '',
  },
  [EHRProvider.TPP_SystmOne]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Vision_Health]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Shexie]: {
    icon: '',
    name: '',
  },
  [EHRProvider.IntakeQ]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Mediclinic]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Power_Diary]: {
    icon: '',
    name: '',
  },
  [EHRProvider.TherapyNotes]: {
    icon: '',
    name: '',
  },
  [EHRProvider.SimplePractice]: {
    icon: '',
    name: '',
  },
  [EHRProvider.MyOutcomes]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Nookal]: {
    icon: imageNookal,
    name: 'Nookal',
  },
  [EHRProvider.TheraNest]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Magentus_Genie_]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Orion_Health]: {
    icon: '',
    name: '',
  },
  [EHRProvider.InterSystems]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Access_Rio]: {
    icon: '',
    name: '',
  },
  [EHRProvider.iaptus_by_Mayden]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Meditech_Expanse]: {
    icon: '',
    name: '',
  },
  [EHRProvider.WebPT]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Avaros]: {
    icon: '',
    name: '',
  },
  [EHRProvider.BlueprintOMS]: {
    icon: '',
    name: '',
  },
  [EHRProvider.BodySite]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Carebit]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Charm]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Client_Care]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Cornerstone]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Counselear]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Counsol]: {
    icon: '',
    name: '',
  },
  [EHRProvider.e_MDS]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Elation]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Galaxy]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Gensolve]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Gentu]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Google_Calendar]: {
    icon: '',
    name: 'Google Calendar',
  },
  [EHRProvider.Halaxy]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Headway]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Healthie]: {
    icon: '',
    name: '',
  },
  [EHRProvider.HealthQuest]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Helix]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Indici]: {
    icon: '',
    name: '',
  },
  [EHRProvider.JunoOscar]: {
    icon: '',
    name: '',
  },
  [EHRProvider.MDLand]: {
    icon: '',
    name: '',
  },
  [EHRProvider.MedServ_RPM]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Micro_Quest]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Midex_Pro]: {
    icon: '',
    name: '',
  },
  [EHRProvider.MyOsteopathy]: {
    icon: '',
    name: '',
  },
  [EHRProvider.MyVirtualCare]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Nephro]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Nephro7]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Notability]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Optimantra]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Oscar_Pro]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Osmind]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Outsmart]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Owl]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Pabau]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Patient_Now]: {
    icon: '',
    name: '',
  },
  [EHRProvider.PPMS]: {
    icon: '',
    name: '',
  },
  [EHRProvider.PracSuite]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Practice_Better]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Praxis]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Prognocis]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Renesan]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Rx]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Semble]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Splose]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Telus]: {
    icon: '',
    name: '',
  },
  [EHRProvider.TextFlow]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Therabill]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Therabyte]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Therapymate]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Timely]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Unified_Practice]: {
    icon: '',
    name: '',
  },
  [EHRProvider.UroChart_EHR]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Veradigm_EHR]: {
    icon: imageVeradigm,
    name: 'Veradigm',
  },
  [EHRProvider.VIP]: {
    icon: '',
    name: '',
  },
  [EHRProvider.WriteUpp]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Xestro]: {
    icon: '',
    name: '',
  },
  [EHRProvider.ZHealthEHR]: {
    icon: '',
    name: '',
  },
  [EHRProvider.CareStack]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Other]: {
    icon: '',
    name: '',
  },
  [EHRProvider.InstantScripts]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Better_Clinics]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Heidi]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Accuro]: {
    icon: imageAccuro,
    name: 'Accuro',
  },
  [EHRProvider.Adoreal]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Akute_Health]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Alaya_Care]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Automated_Medical_Assistant]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Big_Picture_Medical]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Biocanic]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Blueprint_Solutions]: {
    icon: '',
    name: '',
  },
  [EHRProvider.ClaimPower]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Genius]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Hefficient]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Healthdirect]: {
    icon: ImageHealthdirect,
    name: 'Healthdirect',
  },
  [EHRProvider.Keiser]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Keyreply]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Magentus]: {
    icon: imageMagentus,
    name: 'Magentus Gentu',
  },
  [EHRProvider.MediOffice]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Practice_Hub]: {
    icon: '',
    name: '',
  },
  [EHRProvider.PracticeQ]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Renvio]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Sound_Business]: {
    icon: '',
    name: '',
  },
  [EHRProvider.StrongroomAI]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Suvera]: {
    icon: '',
    name: '',
  },
  [EHRProvider.TalkNow]: {
    icon: '',
    name: '',
  },
  [EHRProvider.USW]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Weva]: {
    icon: '',
    name: '',
  },
  [EHRProvider.WRS]: {
    icon: '',
    name: '',
  },
  [EHRProvider.xyCare]: {
    icon: '',
    name: 'xyCare',
  },
  [EHRProvider.Mindbody]: {
    icon: imageMindbody,
    name: 'Mindbody',
  },
  [EHRProvider.ALBIS]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Anderes_System]: {
    icon: '',
    name: '',
  },
  [EHRProvider.ARZT_2000]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Avelios]: {
    icon: '',
    name: '',
  },
  [EHRProvider.CGM_CLINICAL]: {
    icon: '',
    name: '',
  },
  [EHRProvider.CGM_M1_PRO]: {
    icon: '',
    name: '',
  },
  [EHRProvider.CGM_MEDICO]: {
    icon: '',
    name: '',
  },
  [EHRProvider.CGM_MEDISTAR]: {
    icon: '',
    name: '',
  },
  [EHRProvider.ClinicCentre]: {
    icon: '',
    name: '',
  },
  [EHRProvider.ClinicCentre_Billing]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Data_AL]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Doctorly]: {
    icon: '',
    name: '',
  },
  [EHRProvider.DURIA]: {
    icon: '',
    name: '',
  },
  [EHRProvider.DURIA2]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Elefant]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Epikur]: {
    icon: '',
    name: '',
  },
  [EHRProvider.esQlab_online]: {
    icon: '',
    name: '',
  },
  [EHRProvider.EVA]: {
    icon: '',
    name: '',
  },
  [EHRProvider.EVIDENT]: {
    icon: '',
    name: '',
  },
  [EHRProvider.FIDUS]: {
    icon: '',
    name: '',
  },
  [EHRProvider.IMedOne]: {
    icon: '',
    name: '',
  },
  [EHRProvider.IMP_System]: {
    icon: '',
    name: '',
  },
  [EHRProvider.inSuite]: {
    icon: '',
    name: '',
  },
  [EHRProvider.InterARZT]: {
    icon: '',
    name: '',
  },
  [EHRProvider.KiWi]: {
    icon: '',
    name: '',
  },
  [EHRProvider.medatixx]: {
    icon: '',
    name: '',
  },
  [EHRProvider.MEDAVIS_RIS]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Medical_Office]: {
    icon: '',
    name: '',
  },
  [EHRProvider.medico]: {
    icon: '',
    name: '',
  },
  [EHRProvider.MEDYS]: {
    icon: '',
    name: '',
  },
  [EHRProvider.M_KIS]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Nexsoft]: {
    icon: '',
    name: '',
  },
  [EHRProvider.NEXUS_KIS]: {
    icon: '',
    name: '',
  },
  [EHRProvider.ORBIS]: {
    icon: '',
    name: '',
  },
  [EHRProvider.ORBIS_U]: {
    icon: '',
    name: '',
  },
  [EHRProvider.PegaMed]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Praxis_Programm]: {
    icon: '',
    name: '',
  },
  [EHRProvider.PROFIMED]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Pro_Medico]: {
    icon: '',
    name: '',
  },
  [EHRProvider.PsychoDat]: {
    icon: '',
    name: '',
  },
  [EHRProvider.psyprax]: {
    icon: '',
    name: '',
  },
  [EHRProvider.PsyPrax_KIS]: {
    icon: '',
    name: '',
  },
  [EHRProvider.QUINCY_WIN]: {
    icon: '',
    name: '',
  },
  [EHRProvider.RED_Medical]: {
    icon: '',
    name: '',
  },
  [EHRProvider.RescuePro]: {
    icon: '',
    name: '',
  },
  [EHRProvider.S3_Win]: {
    icon: '',
    name: '',
  },
  [EHRProvider.SAP_IS_H_i_s_h_med]: {
    icon: '',
    name: '',
  },
  [EHRProvider.SMARTY]: {
    icon: '',
    name: '',
  },
  [EHRProvider.T2med]: {
    icon: '',
    name: '',
  },
  [EHRProvider.tomedo]: {
    icon: '',
    name: '',
  },
  [EHRProvider.TURBOMED]: {
    icon: '',
    name: '',
  },
  [EHRProvider.vianova_KIS]: {
    icon: '',
    name: '',
  },
  [EHRProvider.XCare]: {
    icon: '',
    name: '',
  },
  [EHRProvider.x_comfort]: {
    icon: '',
    name: '',
  },
  [EHRProvider.x_concept]: {
    icon: '',
    name: '',
  },
  [EHRProvider.x_isynet]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Vim]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Airrosti]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Hero_Health]: {
    icon: '',
    name: '',
  },
  [EHRProvider.eClinicalWorks_EHR_Launch]: {
    icon: '',
    name: '',
  },
  [EHRProvider.nCAS_EHR_Launch]: {
    icon: '',
    name: 'NCAS EHR Launch',
    ehrLaunch: true,
  },
  [EHRProvider.Telus_CHR_EHR_Launch]: {
    icon: '',
    name: 'Telus CHR EHR Launch',
    ehrLaunch: true,
  },
  [EHRProvider.SGIMED]: {
    icon: '',
    name: '',
  },
  [EHRProvider.xentro]: {
    icon: '',
    name: '',
  },
  [EHRProvider.x_vianova]: {
    icon: '',
    name: '',
  },
  [EHRProvider.Sandwell]: {
    icon: '',
    name: 'Sandwell',
  },
  [EHRProvider.BIH]: {
    icon: '',
    name: 'BIH',
  },
  [EHRProvider.KFSH]: {
    icon: '',
    name: 'KFSH',
  },
  [EHRProvider.EasternHealth]: {
    icon: '',
    name: 'Eastern Health',
  },
  [EHRProvider.Walsall]: {
    icon: '',
    name: 'Walsall',
  },
};

// Keyed by the integration-providers API's `unique_id` (lowercase snake_case);
// icon-bearing providers only.
export const integrationMappingByUniqueId: Partial<Record<string, { icon: string }>> = {
  accuro: { icon: imageAccuro },
  athenahealth: { icon: imageAthena },
  best_practice: { icon: imageBP },
  cliniko: { icon: imageCliniko },
  eclinicalworks: { icon: imageEclinicalWorks },
  epic_systems: { icon: imageEpic },
  healthdirect: { icon: ImageHealthdirect },
  magentus: { icon: imageMagentus },
  mindbody: { icon: imageMindbody },
  nookal: { icon: imageNookal },
  veradigm_ehr: { icon: imageVeradigm },
};
